<template>
  <div id="signup" class="content">
    <div id="">
      <div class="icon">
        <font-awesome-icon icon="info-circle" size="1x"></font-awesome-icon>新元号.jp
      </div>
      <h3 class="mt-3">サインイン</h3>
      <b-button v-b-modal.terms_of_use>利用規約</b-button>
        <b-modal id="terms_of_use" title="利用規約">
        <div class="d-block text-left">
          <h3>第1条 はじめに</h3>
          <ol>
            <li>
              この利用規約は、株式会社イワテシガが提供するサービス「新元号.jp」に関して、利用条件を定めるものです。
              利用者（以下「利用者」）の皆様には、本規約に従うことで本サービスをご利用いただけます。
            </li>
          </ol>
          <h3>第2条 利用者定義と登録</h3>
          <ol>
            <li>
              本サービスの利用者とは、登録利用者とゲスト利用者の総称です。
            </li>
            <li>
              本サービスでは、利用者が低コストで安全にご利用頂けるように、外部認証サービスのみを利用します。
            </li>
            <li>
              そのため、登録利用者となるには本サービス自体の利用者登録作業は不要ですが、事前に提携する外部認証サービス上で利用者登録を行う必要があります。
            </li>
            <li>
              利用者登録は、初回認証時に行われます。
            </li>
            <li>
              現在連携している外部認証サービスは、Google, GitHubです。
            </li>
          </ol>
          <h3>第3条 利用者認証と利用情報</h3>
          <ol>
            <li>
              利用者認証は、連携サービス上における認証手段と方法を用いて行います。
            </li>
            <li>
              外部認証サービスにおいて取得する情報は、利用者識別子、メールアドレスと登録名、登録写真のみであり、当サービス内部においてはパスワード等の認証情報は保存することはありません。
            </li>
          </ol>         
        </div>
      </b-modal>
      <div id="firebaseui-auth-container"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "signup",
  components: {},
  methods: {
    signinWithGitHub() {
      let firebase = this.$firebase;
      let provider = new firebase.auth.GithubAuthProvider();
      //provider.addScope();
      provider.setCustomParameters({
        allow_signup: "false"
      });
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          let token = result.credential.accessToken;
          let user = result.user;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted() {
    console.log("mounted");
    let firebase = this.$firebase;
    let firebaseui = this.$firebaseui;
    
    this.$authUI.start("#firebaseui-auth-container", {
      signInSuccessUrl: "/",
      signInOptions: [
        // List of OAuth providers supported.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        firebase.auth.GithubAuthProvider.PROVIDER_ID
      ]
      // Other config options...
    });
  }
};
</script>

<style>
#signup.content {
  background-color: #fefefe;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#signup .icon {
  color: red;
  text-align: center;
  font-size: 2em;
  margin-top: 1em;
}

#logreg-forms {
  width: 412px;
  margin: 10vh auto;
  background-color: #ffffff4d;
  box-shadow: 0 7px 7px rgba(0, 0, 0, 0.12), 0 12px 40px rgba(0, 0, 0, 0.24);
  border-radius: 1em;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

#logreg-forms form {
  width: 100%;
  max-width: 410px;
  padding: 15px;
  margin: auto;
}
#logreg-forms .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
#logreg-forms .form-control:focus {
  z-index: 2;
}
#logreg-forms .form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
#logreg-forms .form-signin input[type="password"] {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

#logreg-forms .social-login {
  width: 380px;
  margin: 0 auto;
  margin-bottom: 14px;
}
#logreg-forms .social-btn {
  font-weight: 100;
  color: white;
  width: 190px;
  font-size: 0.9rem;
}

#logreg-forms a {
  display: block;
  padding-top: 10px;
  color: #fff;
}

#logreg-form .lines {
  width: 200px;
  border: 1px solid red;
}

#logreg-forms button[type="submit"] {
  margin-top: 10px;
}

#logreg-forms .facebook-btn {
  background-color: #3c589c;
}

#logreg-forms .google-btn {
  background-color: #df4b3b;
}

#logreg-forms .github-btn {
  background-color: #000;
}

#logreg-forms .form-reset,
#logreg-forms .form-signup {
  display: none;
}

#logreg-forms .form-signup .social-btn {
  width: 210px;
}

#logreg-forms .form-signup input {
  margin-bottom: 2px;
}

.form-signup .social-login {
  width: 420px !important;
  margin: 0 auto;
}

.submit {
  background: -webkit-linear-gradient(0deg, #2dfbff 0%, #3c96ff 100%);
  border-radius: 25px;
  color: #fff;
}

/* Mobile */

@media screen and (max-width: 500px) {
  #logreg-forms {
    width: 300px;
  }

  #logreg-forms .social-login {
    width: 200px;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  #logreg-forms .social-btn {
    font-size: 1.3rem;
    font-weight: 100;
    color: white;
    width: 400px;
    height: 56px;
  }
  #logreg-forms .social-btn:nth-child(1),
  :nth-child(2) {
    margin-bottom: 0px;
  }
  #logreg-forms .social-btn span {
    display: none;
  }
  #logreg-forms .facebook-btn:after {
    content: "Facebook";
  }

  #logreg-forms .google-btn:after {
    content: "Google+";
  }
  #logreg-forms .github-btn:after {
    content: "GitHub";
  }
}
</style>

